import React from "react";
import BaseClientsList from "./BaseClientsList";
const ArchivedClientList = (props) => {
  return <BaseClientsList {...props} filterKey="isArchive" />;
};

export default ArchivedClientList;